import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

// ANT DESIGN IMPORTS
import { Spin, Typography, Table, Divider, Card, Form, Tag } from "antd";
import {
  FolderOpenOutlined,
  EditOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
// import NewStandingInstruction from "./NewStandingInstruction";
import DetailedStandingInstruction from "./DetailStandingInstruction";
import EditStandingInstruction from "./EditStandingInstruction";
const { Text, Link, Title } = Typography;

const ManageStandingInstructions = (props) => {
  const { userData, state, clientOfficeData } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  // const { state } = useLocation();

  const [standingInstructionsList, setStandingInstructionsList] = useState([]);
  const [initialStandingInstructionLIst, setInitialStandingInstructionLIst] =
    useState([]);
  const [transferTypeList, setTransferTypeList] = useState([]);
  const [toAccountTypeList, setToAccountTypeList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(state);

    console.log(BOM.HasPermission("READ_STANDINGINSTRUCTION"));

    BOM.HasPermission("READ_STANDINGINSTRUCTION") && getTemplate();

    BOM.HasPermission("READ_STANDINGINSTRUCTION") &&
      getStandingInstructionListAction();
  }, []);

  const columns = [
    {
      title: "From  Account",
      dataIndex: "fromAccount",
    },

    {
      title: "Beneficiary",
      dataIndex: "beneficiary",
    },
    {
      title: "To Account",
      dataIndex: "toAccount",
    },

    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, record) => {
        return <Text> {handleFlgStatus(record?.status, {}, true)}</Text>;
      },
    },
    {
      title: "Validity",
      dataIndex: "validity",
    },
    {
      title: "Action",
      dataIndex: "status",
      render: (_, record) => (
        <>
          {BOM.HasPermission("READ_STANDINGINSTRUCTION") && (
            <DetailedStandingInstruction
              state={state}
              userData={userData}
              standingObj={record}
              refreshList={getStandingInstructionListAction}
            />
          )}
          &nbsp;
          {_ !== "Deleted" &&
            BOM.HasPermission("UPDATE_STANDINGINSTRUCTION") && (
              <EditStandingInstruction
                state={state}
                userData={userData}
                standingObj={record}
                refreshList={getStandingInstructionListAction}
              />
            )}
        </>
      ),
    },
  ];

  const getTemplate = () => {
    setIsLoading(true);

    const url = `${apiConfig.standingInstructions}/template`;

    const params = {
      fromAccountType: 2,
      fromClientId: state.clientId,
      fromOfficeId: clientOfficeData.officeId,
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        let tempTransferTypeOptions = [];
        let tempToAccountTypeOptions = [];

        useForm.setFieldsValue({
          officeId: objList.officeId,
          fullname: objList?.fromClient?.fullname,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeList(tempTransferTypeOptions);
        setToAccountTypeList(tempToAccountTypeOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };



  const getStandingInstructionListAction = () => {
    setIsLoading(true);
    const url = `${apiConfig.standingInstructions}`;
    const params = {
      fromAccountId: state.id,
      clientId: state.clientId,
      clientName: state.clientName,
      dateFormat: "dd+MMMM+yyyy",
      // limit: 14,
      locale: "en",
      offset: 0,
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            client: element?.fromClient?.displayName
              ? element?.fromClient?.displayName
              : "-",
            fromAccount: element?.fromAccount?.accountNo
              ? `${element?.fromAccount?.accountNo}(${element?.fromAccountType?.value})`
              : "-",
            fromAccountType: element?.fromAccountType?.value
              ? `${element?.fromAccountType?.value}`
              : "-",
            beneficiary: element?.toClient?.displayName
              ? element?.toClient?.displayName
              : "-",
            toAccount: element?.toAccount?.accountNo
              ? `${element?.toAccount?.accountNo}(${element?.toAccountType?.value})`
              : "-",
            toAccountType: element?.toAccountType?.value
              ? `${element?.toAccountType?.value}`
              : "-",
            amount: element?.amount ? element?.amount : "-",
            status: element?.status?.value ? element?.status?.value : "-",
            validity: element?.validFrom
              ? ` ${BOM.DateTime(element?.validFrom, "only-date")} -
                ${
                  element?.validTill
                    ? BOM.DateTime(element?.validTill, "only-date")
                    : "No date"
                }`
              : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setInitialStandingInstructionLIst(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };


  const handleFlgStatus = (status, style = {}, isListing = false) => {
    switch (status.toLowerCase()) {
      case "active":
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "success" : "#87D068"}`}
            style={style}
          >
            {status}
          </Tag>
        );

      case "disabled":
        return (
          <Tag
            icon={<ClockCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {BOM.SubstringFormat(status, 21)}
          </Tag>
        );
      default:
        return (
          <Tag
            icon={<CloseCircleOutlined />}
            color={`${isListing ? "#F9FAFB" : "#F9FAFB"}`}
            style={{ color: "black", ...style }}
          >
            {status}
          </Tag>
        );
    }
  };

  return (
    <>
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Table
          columns={columns}
          dataSource={initialStandingInstructionLIst}
          bordered
          pagination={{
            position: "bottomCentre",
            // pageSize: tableCount,
          }}
        />
      </Spin>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(ManageStandingInstructions);
